// src/components/LayerPanel/ToggleSwitch.jsx
//
// Compact on/off pill used by the layer-panel tabs (Features rows, My Layers
// rows). Panel-scoped — not used elsewhere in the app.

function cx(...c) { return c.filter(Boolean).join(" "); }

export default function ToggleSwitch({ on }) {
  return (
    <span
      className={cx(
        "flex-shrink-0 w-7 h-4 flex items-center rounded-full px-0.5 transition-colors",
        on ? "bg-accent-info/80" : "bg-slate-700"
      )}
    >
      <span
        className={cx(
          "w-3 h-3 rounded-full bg-bg-soft transform transition-transform",
          on ? "translate-x-3" : ""
        )}
      />
    </span>
  );
}
